import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-6">
              <span className="text-orange-600">Prayatne</span> Sanstha
            </h3>
            <p className="text-gray-400 leading-relaxed mb-4">
              Founded in 1992, Prayatne Sanstha works towards enabling people to respond to and 
              change their situation of inequality and injustice through education, awareness, and community involvement.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  About Us
                </a>
              </li>
              <li>
                <a href="#interventions" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  Our Interventions
                </a>
              </li>
              <li>
                <a href="#news" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  News & Events
                </a>
              </li>
              <li>
                <a href="#stories" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  Impact Stories
                </a>
              </li>
              <li>
                <a href="#publications" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  Publications
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="text-orange-600 flex-shrink-0 mt-1" size={20} />
                <a href="mailto:support@prayatne.org" className="text-gray-400 hover:text-orange-600 transition-colors duration-200">
                  support@prayatne.org
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-orange-600 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">+91-141-2792904</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-600 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">
                  Jaipur, Rajasthan, India
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-xl font-bold mb-6">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
              >
                <Instagram size={20} />
              </a>
            </div>
            <p className="text-gray-400 mt-6 text-sm">
              Stay connected with us on social media for updates on our work and impact.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Prayatne Sanstha. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-orange-600 text-sm transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-600 text-sm transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;